<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-top">
                    <div class="row">

                        <div class="col-lg-6">
                            <div class="about-enago">
                                <h3>关于Trinka</h3>
                                <p>
                                    Trinka AI 是一款注重隐私的英语语法检查和语言优化写作助手，专为学术和技术写作量身打造。它帮助专业人士和学者确保写作风格更加正式、简洁且富有吸引力。Trinka 的企业级解决方案提供全面的功能访问、多样化的集成选项，以及完全的数据掌控能力，可根据您的需求灵活定制。
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="install-in">
                                <h3>在以下程序中使用</h3>
                                <ul>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/wordplugin">
                                                <img src="assets/images/NewWordAdd_in.svg" alt=""> </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/wordplugin">微软Word (Windows)</a>
                                        </span>
                                        <!-- <a routerLink="/wordplugin"></a> -->
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin">
                                                <img src="assets/images/NewChromeFicon.svg" alt="">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">谷歌浏览器</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin">
                                                <img src="assets/images/NewFirefoxFicon.svg" alt="">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">火狐浏览器</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin">
                                                <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt=""
                                                    width="42">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">微软边缘浏览器</a>
                                        </span>

                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <img src="assets/images/UpcomingWord.svg" alt="">
                                        </span>
                                        <span class="install-in-browser">Mac版Word</span>
                                    </li>
                                    <li>
                                        <span class="browser-icon upcoming-icon">
                                            <img src="assets/images/UpcomingSafari_icon.png" alt="">
                                        </span>
                                        <span class="install-in-browser">Safari浏览器</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="contact" id="footerEmailBox">
                                <form class="form-inline" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
                                    <div class="form-group mx-sm-3 mb-2 ml-0"
                                        [ngClass]="(!footerFroms.get('footeremailform').valid && footerFroms.get('footeremailform').dirty) || (footerFroms.get('footeremailform').touched && footerFroms.get('footeremailform').pristine) ? 'TextFiledError' : '' ">

                                        <mat-form-field appearance="outline">
                                            <mat-label>您用来接收Trinka新闻的电子邮件</mat-label>
                                            <input matInput placeholder="" formControlName="footeremailform"
                                                class="form-control" name="email">
                                        </mat-form-field>
                                    </div>
                                    <button type="submit" [disabled]="!footerFroms.valid" id="footerSubscribe"
                                        class="btn btn-primary mb-2">订阅</button>
                                </form>
                            </div>

                        </div>


                    </div>
                    <div class="row">

                        <div class="col-lg-12">
                            <div class="row footer_menu_wrap">
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>公司介绍</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/aboutus']" routerLinkActive="active">关于我们</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/contactus']" routerLinkActive="active">联系我们</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/workwithus']" routerLinkActive="active">加入我们</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/affiliates']" routerLinkActive="active">联盟营销</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/accomplishments']" routerLinkActive="active">Accomplishments</a>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h3>学到更多</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a href="https://www.trinka.ai/blog/"  target="_blank">博客</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/examples']" routerLinkActive="active">实例</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/faqs']" routerLinkActive="active">常见问答</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>特色</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features']" routerLinkActive="active">所有特色</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/plagiarism-check']"
                                                    routerLinkActive="active">抄袭检测</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/auto-file-edit']"
                                                    routerLinkActive="active">自动文件编辑</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/publication-readiness-checks']"
                                                    routerLinkActive="active">出版准备检查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/citation-checker']" routerLinkActive="active">引文检查器</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/consistency-check']"
                                                    routerLinkActive="active">一致性检查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']"
                                                    routerLinkActive="active">个人词典</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/credits']"
                                                    routerLinkActive="active">语法检查工具</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>企业解决方案</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']"
                                                    routerLinkActive="active">
                                                    生命科学、医学和制药
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/language-services-publishing-and-media']"
                                                    routerLinkActive="active">
                                                    语言服务、出版和媒体
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/academic-institutions']"
                                                    routerLinkActive="active">
                                                    学术机构
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/k12-and-elearning']"
                                                    routerLinkActive="active">
                                                    K-12和数字化学习
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/technology-platforms']"
                                                    routerLinkActive="active">
                                                    技术平台
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">企业集成</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">语法检查工具 API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/documark']" routerLinkActive="active">DocuMark</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>竞品比较</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly']"
                                                    routerLinkActive="active">Trinka vs. Grammarly</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-ginger']" routerLinkActive="active">Trinka
                                                    vs. Ginger</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-languagetool']"
                                                    routerLinkActive="active">Trinka vs. LanguageTool</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-writefull']"
                                                    routerLinkActive="active">Trinka vs. Writefull</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" routerLinkActive="active">白皮书</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>资源</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/grammar-checker']" routerLinkActive="active">语法检查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">标点符号检查工具</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/spell-checker']" routerLinkActive="active">拼写检查工具</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/sentence-checker']" routerLinkActive="active">句子检查工具</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="purple-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>若需要协助，请写信到
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>给我们
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="FooterseparatorLine"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-middle">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="powerd-by">
                                <div class="powered-by-left">
                                    <h3>技术支持</h3>
                                    <p>
                                        <a href="https://www.enago.cn/" target="_blank" class="footer_logos">
                                            <img src="assets/images/enago-logo.png" width="140" height="40"
                                                alt="enago-english-editing-service" class="enago logo" />
                                        </a>
                                    </p>
                                </div>
                                <div class="powered-by-right">
                                    <p>英论阁Enago是备受全球研究界信赖的学术服务品牌，已为来自全球125个国家的研究人员优化科研成果表达，助力其成功发表。</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="footer_menu_one footer_menu_last">
                                <h3>英论阁服务</h3>
                                <ul class="ftr-menu">
                                    <li>
                                        <a href="https://www.enago.cn/editing-services.htm" target="_blank">英文润色</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.cn/publication-support/" target="_blank">投稿服务</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.cn/fanyi/tougaoji-fanyi.htm" target="_blank">翻译服务</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.com/plagiarism-checker/"
                                            target="_blank">抄袭检查</a>
                                    </li>
                                    <li>
                                        <a href="https://voxtab.com/" target="_blank">转录和字幕服务</a>
                                    </li>
                                    <li>
                                        <a href="https://lifesciences.enago.cn/" target="_blank">全球医疗通讯</a>
                                    </li>
                                    <li>
                                        <a href="https://www.read.enago.com/" target="_blank">文献回顾与分析工具</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-bottom">
                    <div class="row">
                        <div class="col-lg-7 col-md-12">
                            <p>© Crimson AI, {{ latestYear }}. 克里门森互动（北京）顾问有限公司.</p>
                            <ul class="ftr-menu1">
                                <li>
                                    <a href="mailto:support@trinka.ai">support@trinka.ai</a>
                                </li>
                                <li>
                                    <a id="PrivacyButton" href="https://www.trinka.ai/privacypolicy/"
                                        target="_blank">隐私政策</a>
                                </li>
                                <li>
                                    <a id="termsofserviceButton" href="https://www.trinka.ai/termsofservices/"
                                        target="_blank">服务条款</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-5 col-md-12">
                            <div class="follow-us">
                                <h3>关注我们</h3>
                                <ul class="social-media">
                                    <li>
                                        <a href="" rel=" no referer, no opener">
                                            <i class="fa fa-weixin" aria-hidden="true"></i>
                                            <div class="weChatBarCode">
                                                <img src="assets/images/weChatBarCode.png" alt="">
                                                <span>ID:Trinka AI</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://weibo.com/trinka2022/" rel=" no referer, no opener"
                                            target="_blank">
                                            <i class="fa fa-weibo" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <!-- <li>
                                        <a href="https://twitter.com/ai_trinka" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li> -->
                                    <li>
                                        <a href="https://www.linkedin.com/company/thetrinkaai"
                                            rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://space.bilibili.com/1145147915"
                                            rel=" no referer, no opener" target="_blank">
                                            <svg version="1.1" id="Bilibili" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 2186.86 999.65"
                                                style="enable-background:new 0 0 2186.86 999.65;" xml:space="preserve">
                                                <style type="text/css">
                                                    .st0 {
                                                        fill: #4d4d4d;
                                                    }
                                                </style>
                                                <g>
                                                    <path class="st0" d="M2030.61,892.82c-9.77,0-18.55,0-26.37-0.98c-16.6-0.97-33.2-1.95-49.8-1.95c-10.74,0-10.74,0-11.72-10.74
                                                        l-15.63-177.74l-15.62-147.46l-10.74-90.82l-9.77-79.1l-17.58-123.05c-5.86-43.94-12.69-86.91-21.48-130.86
                                                        c-0.98-6.83-0.98-7.81,6.84-8.79c30.27-5.86,61.52-8.79,92.77-8.79h10.74c4.88,0.98,7.81,3.91,8.79,9.77l3.91,67.38l27.34,364.26
                                                        l13.67,166.99l8.79,95.71L2030.61,892.82L2030.61,892.82z M833.34,112.54h17.58c8.79,0,10.74,2.93,10.74,11.72l7.82,118.17
                                                        l17.58,245.11l10.74,127.93l7.81,98.64l15.63,169.92c0,7.81-0.98,8.79-8.79,8.79l-70.32-2.93c-4.88,0.98-7.81-1.95-7.81-6.84
                                                        l-2.93-34.18c-2.93-29.29-5.86-58.59-7.81-88.86l-15.63-154.3l-16.6-139.65l-11.72-98.63l-12.69-89.85
                                                        c-5.86-40.04-12.7-81.05-19.53-121.09l-4.89-27.34c-0.97-4.89,0-6.84,4.89-7.82C774.75,116.45,801.12,111.57,833.34,112.54
                                                        L833.34,112.54L833.34,112.54z M1815.77,506.1c24.41,0,27.34,0.98,31.25,24.41c4.88,29.3,8.79,58.6,11.72,87.89l10.74,94.73
                                                        l20.51,201.17c0.97,4.89,0,6.84-4.89,6.84l-76.17,8.79c-7.81,0.97-9.77,0-10.74-7.81l-43.95-224.61l-27.34-149.42l-3.91-20.51
                                                        c-0.97-3.9,0.98-6.83,4.89-7.81C1758.15,512.94,1787.45,508.05,1815.77,506.1L1815.77,506.1L1815.77,506.1z M705.41,506.1
                                                        c26.37-0.98,29.3,1.95,32.23,26.37c6.84,40.04,11.72,79.1,15.63,119.14l12.69,117.18l7.81,79.11l6.84,63.47
                                                        c0,8.79-0.98,10.75-8.79,11.72l-72.26,6.84c-7.82,0.97-9.77,0-10.75-7.81l-59.57-306.65l-15.62-86.91
                                                        c-0.98-4.88,0.97-7.81,5.86-8.79C649.75,512.94,678.07,508.05,705.41,506.1L705.41,506.1L705.41,506.1z M1078.46,808.83v121.1v3.9
                                                        c0.98,5.86-1.95,8.79-7.81,7.82h-23.44c-16.6,0-33.2,0.97-49.8,1.95c-8.79,0.98-9.77,0.98-10.75-9.77l-15.62-175.78l-7.81-86.91
                                                        l-11.72-132.81c-0.98-10.75,0.98-12.7,9.76-13.68c27.35-2.93,54.69-2.93,82.04-1.95l20.5,2.93c7.82,2.93,8.79,3.91,8.79,11.72
                                                        l2.93,52.73l0.98,58.6C1077.49,702.39,1078.46,755.12,1078.46,808.83L1078.46,808.83L1078.46,808.83z M2186.86,814.69v114.26v5.86
                                                        c0,4.88-1.95,7.81-6.84,6.84h-35.15c-13.67,0-27.35,0.97-40.04,1.95c-7.81,0.98-8.79,0-9.77-8.79l-20.5-228.52l-10.75-113.28
                                                        l-3.9-57.61c-0.98-7.82,0.97-9.77,8.79-9.77c32.22-3.91,65.43-4.88,97.65-0.98c12.7,0.98,14.65,4.89,15.63,17.58l2.93,129.88
                                                        L2186.86,814.69L2186.86,814.69z M1787.45,298.09c9.76,0,18.55,0.98,25.39,1.95c4.88,0.98,6.83,2.93,7.81,7.82l12.69,135.74
                                                        c2.93,11.72,0.98,13.67-10.74,13.67l-33.2,1.95c-6.84,0.98-9.77,1.96-9.77-8.78l-13.67-110.36l-3.9-31.25
                                                        c-0.98-5.86,0.97-8.79,6.83-9.76L1787.45,298.09L1787.45,298.09z M681,298.09c7.81,0,15.63,0.98,22.46,1.95
                                                        c3.91,0.98,5.86,2.93,6.84,7.82l3.9,34.18l9.77,106.44c0.98,7.81,0.98,8.79-6.84,8.79l-38.08,1.95c-7.81,0.98-8.79,0-9.77-7.81
                                                        l-8.79-78.12l-7.81-65.43c-0.98-4.89,0.98-7.82,5.86-7.82C665.38,299.07,673.19,298.09,681,298.09L681,298.09L681,298.09z
                                                        M1070.65,395.75v67.38c0.98,10.74-0.98,10.74-9.77,10.74c-12.69,0-24.41-0.97-36.13-1.95c-7.81-0.98-8.79-0.98-7.81-8.79
                                                        l-2.93-83.01c0-18.55,0-37.11-0.98-55.66c-0.97-8.79,0-9.77,8.79-9.77c13.67,0,27.34,0.98,41.02,2.93c7.81,0,7.81,1.96,7.81,9.77
                                                        V395.75L1070.65,395.75z M2180.02,396.72v67.39c0,8.79-0.97,9.76-9.76,9.76l-37.11-1.95c-5.86-0.98-8.79-3.91-7.81-8.79
                                                        l-2.93-139.65c0-7.81,0.97-8.79,8.79-8.79c12.69,0,24.41,0.98,36.13,1.96c14.65,0.97,12.69,3.9,12.69,14.64L2180.02,396.72
                                                        L2180.02,396.72z M650.73,449.46c0.97,11.72,0,13.67-11.72,14.65l-23.44,5.86c-7.81,2.93-8.79,0.97-9.76-5.86l-24.42-137.7
                                                        c-2.93-8.79-0.98-10.74,7.81-11.72l34.18-5.86c7.82-0.97,9.77-0.97,9.77,6.84c2.93,16.6,5.86,33.2,7.81,49.8l9.77,78.13
                                                        L650.73,449.46L650.73,449.46z M1689.79,315.67c14.65-2.93,30.27-4.88,45.9-6.84c4.88-0.97,6.83,1.96,7.81,6.84l7.81,53.71
                                                        c3.91,26.37,6.84,52.73,7.82,79.1v7.81c0.97,3.91-0.98,6.84-4.89,7.82l-31.25,6.83c-4.88,0.98-6.83-0.97-7.81-5.86l-25.39-145.5
                                                        V315.67L1689.79,315.67z M996.43,421.14c0,15.62-0.98,30.27-1.95,43.94c0,4.89-1.96,6.84-6.84,7.82l-30.27,2.93
                                                        c-4.88,0.97-6.84-1.96-6.84-6.84c-1.95-14.65-2.93-28.32-3.9-42.97c-1.96-26.37-3.91-53.71-4.89-81.05l-1.95-19.53
                                                        c-0.98-3.91,0.98-5.86,4.88-5.86l40.04-2.93c6.84,0,8.79,0.97,8.79,8.79L996.43,421.14L996.43,421.14z M2103.85,405.51
                                                        c0.98,18.56,0.98,38.09,0,56.64c0.98,8.79-0.97,10.75-9.76,10.75l-27.35,2.93c-4.88,0.97-7.81-1.96-7.81-6.84
                                                        c-0.98-24.41-2.93-49.8-4.88-74.22l-3.91-68.36c-0.98-4.88,0.98-6.83,4.88-6.83l39.07-2.93c6.83,0,7.81,0.97,7.81,8.79
                                                        C2103.85,351.8,2104.83,379.15,2103.85,405.51L2103.85,405.51L2103.85,405.51z M612.64,738.52c15.63,18.56,18.56,39.06,11.72,61.52
                                                        c-5.86,21.49-16.6,40.04-32.23,55.67c-25.39,26.37-54.68,47.85-86.91,64.45c-55.66,29.3-113.28,49.81-174.81,60.55
                                                        c-43.94,8.79-87.89,14.65-131.83,17.58c-13.67,0.97-27.34,0.97-41.02,0.97h-29.29c-7.82,0-9.77-1.95-10.75-9.76l-6.83-94.73
                                                        L92.13,708.25l-20.5-177.74l-11.72-94.72l-12.7-90.82c-6.83-49.81-15.62-99.61-24.41-149.42C15.96,155.51,9.13,115.47,0.34,75.44
                                                        c-0.98-4.89,0-8.79,4.88-9.77L140.96,9.03c8.79-3.91,16.6-6.84,25.39-8.79c5.86-0.98,8.79,0.98,7.81,6.84
                                                        c0,15.62,0,31.25-0.97,47.85l-0.98,12.69c-0.97,56.64-0.97,113.28,0,170.9c0.98,49.81,3.91,100.59,6.84,150.39
                                                        c4.88,78.13,12.69,156.25,20.51,233.4c0,7.81,0.97,7.81,9.76,6.84c16.6-2.93,32.23-3.91,48.83-3.91
                                                        c51.76,0,103.51,5.86,153.32,18.55c43.94,10.75,85.94,25.4,127.93,43.95c20.51,9.77,39.06,21.48,56.64,35.16
                                                        C602.88,727.78,607.76,732.66,612.64,738.52L612.64,738.52L612.64,738.52z M1713.23,729.73c20.51,16.6,27.34,39.06,21.48,65.43
                                                        c-4.88,21.49-14.65,40.04-29.3,56.64c-23.43,26.37-50.78,46.88-81.05,63.48c-58.59,32.23-121.09,54.69-187.5,66.41
                                                        c-36.13,6.83-72.27,12.69-108.4,15.62c-20.51,1.95-42.97,2.93-65.43,1.95h-26.37c-5.85,0.98-8.78-1.95-8.78-7.81
                                                        c-1.96-27.34-3.91-54.69-6.84-82.03l-15.63-166.99l-16.6-145.51l-20.5-164.06c-2.93-28.32-6.84-57.62-11.72-85.94l-17.58-109.38
                                                        c-7.81-51.75-17.58-103.51-28.32-155.27l-0.98-6.83c-1.95-4.89,0-8.79,4.88-9.77c47.86-19.53,94.73-41.02,142.58-59.57
                                                        c12.7-4.88,28.32-10.74,27.35,0.98c-3.91,36.13-2.93,72.26-3.91,107.42c-0.98,29.29-0.98,58.59,0.98,86.91v22.46
                                                        c0,35.16,0.97,70.32,3.9,104.49c1.96,45.9,4.89,92.78,8.79,138.68l8.79,98.63c0.98,18.55,2.93,36.13,5.86,54.69
                                                        c0,10.74,1.95,9.76,10.74,8.79c17.58-2.93,35.16-3.91,52.74-3.91c61.52,0.98,121.09,10.74,179.68,27.34
                                                        c40.04,10.75,78.13,25.39,115.24,44.93C1683.93,706.29,1698.58,717.04,1713.23,729.73L1713.23,729.73L1713.23,729.73z
                                                        M301.12,901.61c14.65-8.79,40.04-26.37,75.19-53.71c35.16-28.32,56.64-46.88,65.43-56.64c-52.73-23.44-107.42-43.95-164.06-62.5
                                                        L301.12,901.61L301.12,901.61z M1548.19,796.14c2.93-2.93,1.95-4.88-0.98-6.84l-23.44-9.76c-41.01-17.58-82.03-33.21-124.02-46.88
                                                        l-5.86-1.95c-1.95-0.98-3.9,0-6.83,0.98l23.43,168.94c2.93,0,4.89-0.98,5.86-1.95c38.09-27.35,76.17-55.67,114.26-85.94
                                                        L1548.19,796.14L1548.19,796.14z" />
                                                </g>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="language_sections" id="languageDropDown">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <span>简体中文</span>
                                <ul class="drop">
                                    <li>
                                        <a href="http://www.trinka.ai/">English</a>
                                    </li>
                                    <li>
                                        <a href="http://www.trinka.ai/jp/">
                                            日本語
                                        </a>
                                    </li>
                                    <li class="selected">
                                        <a>
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                            简体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="http://www.trinka.ai/tw/">
                                            繁体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="http://www.trinka.ai/kr/">
                                            한국어
                                        </a>
                                    </li>
                                    <li>
                                        <a href="http://www.trinka.ai/es/">
                                            Español
                                        </a>
                                    </li>
                                </ul>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="emailSubscribePopup" class="modal fade show" *ngIf="subscribePopup">
	<div class="modal-dialog modal-confirm">
		<div class="modal-content">
			<div class="modal-header flex-column">
				<div class="icon-box">
					<i class="material-icons">&#xE5CA;</i>
				</div>						
				<h4 class="modal-title w-100">Thank you for subscribing to our newsletter</h4>	
                <button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
			</div>
			<div class="modal-body">
                <p>Your subscription has been confirmed.</p>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="btn btn-secondary" data-dismiss="modal">OK</button>
				<!-- <button type="button" class="btn btn-danger">Delete</button> -->
                <p>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</p>
			</div>
		</div>
	</div>
</div> 